export class seconds2durationHelper {
    public seconds2duration(nbseconds:any , unbreakspace = false){
        const durationParts = {
            's': 60,
            'mn ': 60,
            'h ': 24,
            'j ': 0
        };

        let sDuration = '';

        const entries = Object.entries(durationParts);
        let i = 0;

        while (i < entries.length && nbseconds > 0) {
            const [label, divisor] = entries[i];
            let value = nbseconds;

            if (divisor !== 0) {
                value = value % divisor;
                nbseconds = Math.floor(nbseconds / divisor);
            }

            sDuration = String(value).padStart(2, '0') + label + sDuration;

            i++;
        }

        if (unbreakspace === true) {
            sDuration = sDuration.replace(/ /g, ' ');
        }

        return sDuration;
    }
}